<template>
  <div>
    <p class="title text-left">重磅：上海小贷行业完成首单同业拆借</p>
    <p class="desc text-left">2018-4-4　<span class="author">及时雨小额贷款</span></p>
    <div class="main-content text-left">
      <p class="normal">2018年4月3日，上海小贷行业首单同业拆借签约仪式在上海嘉定及时雨小额贷款股份有限公司举行。上海市金融办王宏君处长、嘉定区金融办周婉婉主任、上海市小额贷款公司协会李伟涛秘书长，以及签约双方领导，共同出席签约仪式，李伟涛秘书长主持签约仪式。</p>
      <div class="normal"><img src="../img/newsDetail/5-01.png" width="100%" alt=""></div>
      <p class="normal">上海嘉定及时雨小额贷款股份有限公司(以下简称"及时雨小贷)作为拆入方，共向上海嘉定嘉加小额贷款股份有限公司（以下简称"嘉加小贷)拆借资金1000万元,拆借期限为半年。</p>
      <p class="normal">及时雨小贷定位于服务上海的小微企业。经过5年的稳健经营，公司自主研发了服务小微企业的业务系统与风险管理技术，并逐步建立了“超级信贷员+行业模型”的业务模式，即依靠超级信贷员解决小微金融信息不对称难题，依靠行业模型提高信息分析的效率。2017年，公司累计发放贷款12亿元，贷款不良率仅为0.04%。公司信用优良,属于金融办监管第一类小贷公司, 具备达到并突破小贷公司0.5-1倍资金杠杆标准的资质与条件。随着公司小微业务规模的不断扩大，资金成为了限制发展的主要瓶颈。</p>
      <p class="normal">作为一项创新型的融资工具，同业拆借能够灵活补充小贷公司流动性。在市区金融办及上海小贷公司协会的审核及助推下，及时雨小贷与嘉加小贷达成合作。通过此次拆借，能够有效扩大及时雨小贷业务规模，盘活嘉加小贷存量资金，满足小微企业客户的资金需求，实现三方共赢。</p>
      <p class="normal">作为拆出方的上海嘉定嘉加小额贷款股份有限公司成立于2010年1月，注册资本1亿元人民币。截止2018年2月底，公司总资产1.12亿元，净资产1.11亿元，贷款余额8567万元。公司经营稳健，也是金融办监管第一类小贷公司。</p>
      <div class="normal"><img src="../img/newsDetail/5-02.png" width="100%" alt=""></div>
      <p class="normal">上海市、区两级金融办及上海小贷协会急企业之所急，灵活快速提供创新金融政策服务，激活小贷公司同业融资，多一份实力能为中小企业发展送上贷款“及时雨”，意义重大。此次拆借也将为本市小贷公司之间开展同类业务，摸索和积累有益的操作经验。 </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NewsDetail5"
  }
</script>

<style scoped lang="less">
  @import "newsDetail.less";
</style>



// WEBPACK FOOTER //
// src/components/NewsDetail5.vue